{
  "title": "Shutdown (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "5th-level transmutation (technomagic)",
  "level": 5,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "This spell shuts down all electronic devices within range that are not wielded by or under the direct control of a creature. If an electronic device within range is used by a creature, that creature must succeed on a Constitution saving throw to prevent the device from being shut down. While the spell remains active, no electronic device within range can be started or restarted."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
